import { useState, useCallback, useEffect, useMemo } from 'react'
import { useLegendLayerInfo, useViewScale, useLegendLayerOnly } from '../../map/hooks'

import { recordAnalytics_SublayerToggles } from '../../api'

import LegendLayerKey from './LegendLayerKey'

import MAP_DATA from '../../map_data'

const LegendLayerWrapper = ({ mapId, data }) => {
  const { layerId } = data
  const layerInfo = useLegendLayerInfo(mapId, layerId)
  if (layerInfo) {
    return <LegendLayer mapId={mapId} data={data} layerInfo={layerInfo} />
  } else {
    return null
  }
}

const findAnalyticsSublayerId = (layerId, sublayerId) => {
  const sublayers = (MAP_DATA[layerId] && MAP_DATA[layerId].sublayers) || []
  for (let i = 0; i < sublayers.length; i++) {
    if (sublayers[i].id === sublayerId) return sublayers[i].analytics_id
  }
  return 0
}

const LegendLayer = function({ mapId, data }) {
  const { layerId, layerName, minScale, maxScale, legend } = data
  const layer = useLegendLayerOnly(mapId)
  const scale = useViewScale(mapId)

  const sublayer = layer.findSublayerById(layerId)
  const [active, setActive] = useState(sublayer.visible)
  const sublayerAnalyticsId = useMemo(() => findAnalyticsSublayerId(mapId, layerId), [mapId, layerId])

  useEffect(() => {
    setActive(sublayer.visible)
  }, [sublayer])
  
  const toggle = useCallback(() => {
    if (layer) {
      const sublayer = layer.findSublayerById(layerId)
      sublayer.visible = !active
      sublayerAnalyticsId && recordAnalytics_SublayerToggles(sublayerAnalyticsId, !active)
      setActive(!active)
    } else {
      console.error("Missing Layer", mapId, layerName, layerId)
    }
  }, [active, layer, layerId, setActive, mapId, layerName, sublayerAnalyticsId])

  const disabled = (minScale !== 0 && minScale < scale) || (maxScale !== 0 && maxScale > scale)
  const singleLegend = legend.length === 1

  return (
    <li className="map-filter-listing" >
      {!singleLegend && <input
        className="off-the-grid"
        id={`${mapId}-${layerId}-carrot`}
        type="checkbox"
      />}
      {!singleLegend && <label className="key-carrot" htmlFor={`${mapId}-${layerId}-carrot`}><span></span></label>}
      {!disabled && <input className="off-the-grid" id={`${mapId}-${layerId}-label`} type="checkbox" checked={active} onChange={toggle} />}
      <label className="map-filter-item" htmlFor={`${mapId}-${layerId}-label`}>{layerName}{disabled && ' Disabled'}</label>

      {singleLegend && <div className="single-icon"> <img src={`data:image/png;base64,${legend[0].imageData}`} alt={`${legend[0].title} icon`} /></div>}
      {!singleLegend && 
        <div className="legend-wrapper">
          <ul className="legend">
            {legend.map((legendData, i) => <LegendLayerKey key={i} label={legendData.label} imageData={legendData.imageData} index={i} />)}
          </ul>
        </div>
      }
    </li>
  )
}

export default LegendLayerWrapper